import React from "react";
import {
  Toolbar,
  SaveButton,
  Link,
  Button,
  Create,
  SimpleForm,
  FormDataConsumer,
  // DeleteButton,
  DateField,
  ReferenceField,
  List,
  Datagrid,
  FunctionField,
  Pagination,
  CardActions,
  SelectInput,
  Query,
  required,
  EditButton
} from "react-admin";
import { sortBy, path, isEmpty } from "ramda";
import { parse } from "query-string";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";

import styled from "styled-components";

const StyledDiv = styled.div(props => ({
  flexDirection: "column",
  alignItems: props.align ? props.align : "center",
  justifyContent: props.justify ? props.justify : "center",
  backgroundColor: props.color,
  paddingTop: props.padding ? props.padding : "0px",
  paddingBottom: props.padding ? props.padding : "0px",
  minHeight: "40px",
  display: "flex",
  minWidth: "100px"
}));

const TourVanPagination = props => (
  <Pagination rowsPerPageOptions={[10, 25, 50, 100]} {...props} />
);

const cardActionStyle = {
  zIndex: 2,
  display: "inline-block",
  float: "right"
};

const CustomEditTourButton = ({ record = {} }) => {
  return (
    <EditButton
      to={{
        pathname: `/tours/${record.id}/6`
      }}
      target="_blank"
      record={record}
      label="Edit Tour"
    />
  );
};

const ShowActions = ({ basePath, data, resource }) => (
  <CardActions style={cardActionStyle}></CardActions>
);
const validateForm = values => {
  const errors = {};
  if (!values.vehicle_model_id) {
    errors.vehicle_model_id = ["Model is required"];
  }
  if (!values.vehicle_id) {
    errors.vehicle_id = ["Vehicle is required"];
  }
  return errors;
};

const TourVanCreateToolbar = props => (
  <Toolbar {...props}>
    <SaveButton />
    <CancelButton object={props.record} />
  </Toolbar>
);

const ModelData = () => {
  return (
    <Query
      type="GET_LIST"
      resource="vehicle_models"
      const
      payload={{
        filter: { type: 1 },
        pagination: { page: 1, perPage: 1000 },
        sort: { field: "order", order: "ASC" }
      }}
    >
      {({ data, total, loading, error }) => {
        if (loading) {
          return <p>Loading...</p>;
        }
        if (error) {
          return <p>ERROR</p>;
        }
        return (
          <SelectInput
            label="Vehicle Model"
            choices={data}
            validate={required()}
            optionText="model_name"
            optionValue="id"
            source="vehicle_model_id"
          />
        );
      }}
    </Query>
  );
};
const BikeData = ({ tourId, vehicle_model_id }) => {
  return (
    <Query
      type="GET_LIST"
      resource="vehicles"
      const
      payload={{
        pagination: { page: 1, perPage: 1000 },
        filter: { tour_id: tourId, availability: true, vehicle_model_id },
        sort: { field: "id", order: "ASC" }
      }}
    >
      {({ data, loading, error }) => {
        if (loading) {
          return <p>Loading...</p>;
        }
        if (error) {
          return <p>ERROR</p>;
        }
        if (!isEmpty(data)) {
          return (
            <SelectInput
              label="Vehicle"
              choices={data}
              validate={required()}
              optionText="licence_plate"
              optionValue="id"
              source="vehicle_id"
            />
          );
        } else {
          return <p>No vans available</p>;
        }
      }}
    </Query>
  );
};

const CreateTourVanTitle = () => <span>Add tour bike (guide)</span>;

const CancelButton = record => (
  <Button
    component={Link}
    to={{
      pathname: `/tours/${record.object.tour_id}/6`
    }}
    label="Cancel"
  >
    <ArrowBackIcon />
  </Button>
);

export const TourVanCreate = props => {
  const tour_id = parse(props.location.search).tour_id;
  const redirect = tour_id ? `/tours/${tour_id}/6` : "edit";

  return (
    <Create title={<CreateTourVanTitle />} {...props}>
      <SimpleForm
        toolbar={<TourVanCreateToolbar />}
        redirect={redirect}
        validate={validateForm}
      >
        <ModelData />
        <FormDataConsumer>
          {({ formData, ...rest }) => {
            if (formData.vehicle_model_id) {
              return (
                <BikeData
                  tourId={formData.tour_id}
                  vehicle_model_id={formData.vehicle_model_id}
                />
              );
            } else {
              return "";
            }
          }}
        </FormDataConsumer>
      </SimpleForm>
    </Create>
  );
};

export const TourVanList = props => {
  return (
    <List
      {...props}
      perPage={25}
      resource="tour_vans"
      pagination={<TourVanPagination />}
      bulkActionButtons={false}
      filter={{ fromTour: true }}
      actions={<ShowActions />}
      sortable={false}
    >
      <Datagrid>
        <FunctionField
          sortable={false}
          label="Tour"
          render={tour => {
            return `${tour.tour_name.tour_name_en}`;
          }}
        />
        <DateField
          label="Start Date"
          source="tour_start_date"
          sortable={false}
        />
        <DateField label="End Date" source="tour_end_date" sortable={false} />

        <FunctionField
          label="Bikes"
          sortable={false}
          render={tour => {
            console.log(tour);
            return (
              <StyledDiv align="end" padding="10px">
                {sortBy(
                  path(["vehicle", "model", "order"]),
                  tour.tour_vans
                ).map(t => {
                  return (
                    <span>
                      {path(["vehicle", "model", "model_name"], t)} -{" "}
                      {path(["vehicle", "licence_plate"], t)} -{" "}
                      {path(["vehicle", "vehicle_mileage"], t)} km
                    </span>
                  );
                })}
              </StyledDiv>
            );
          }}
        />

        <ReferenceField
          sortable={false}
          source="location_id_1"
          reference="locations"
          linkType={false}
          label="Base"
        >
          <FunctionField
            addLabel={false}
            render={location => {
              return (
                <StyledDiv color={location.color}>
                  {location.location_name}
                </StyledDiv>
              );
            }}
          />
        </ReferenceField>
        <ReferenceField
          sortable={false}
          source="location_id_2"
          reference="locations"
          linkType={false}
          label="Destination"
        >
          <FunctionField
            addLabel={false}
            render={location => {
              return (
                <StyledDiv color={location.color}>
                  {location.location_name}
                </StyledDiv>
              );
            }}
          />
        </ReferenceField>
        {/* <DeleteButton /> */}
        <CustomEditTourButton />
      </Datagrid>
    </List>
  );
};



// WEBPACK FOOTER //
// ./src/resources/tourVans.js